<nz-collapse nzGhost *ngIf="errorTitle">
  <nz-collapse-panel [nzHeader]="titleTemplate" nzShowArrow="false" [ngStyle]="errorStyle">
    <p>{{errorMessage}}</p>
  </nz-collapse-panel>
</nz-collapse>

<ng-template #titleTemplate>
  <nz-alert *ngIf="errorTitle || errorMessage" nzShowIcon [nzType]="type" nzMessage="{{errorTitle}}"
    [nzDescription]="errorMessage">
  </nz-alert>
</ng-template>
